import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'msc-manage-instance-learner',
    templateUrl: './learner.component.html',
    styleUrls: ['./learner.component.scss']
})
export class ManageInstanceLearnerComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}
}
